// Settings → Support log (CR_20260913 S3): the account's managers see every FleetSpoke support visit to it.
import { useTranslation } from 'react-i18next';
import { useSession } from '../../auth/session';
import { Page } from '../../components/Page';
import { SupportLog } from '../../components/SupportLog';

export function SupportLogPage() {
  const { t } = useTranslation();
  const { me } = useSession();
  if (!me?.company) return null;
  return (
    <Page title={t('support.log_title')}>
      <SupportLog
        companyId={me.company.id}
        timeZone={me.company.timezone}
        intro={t('support.log_intro_customer')}
        linkRecords
      />
    </Page>
  );
}
